
function jQueryAjax(url, payload, methodName, successCallBack, errorCallBack) {
    var p = new Promise(function(resolve, reject) {
        $.ajax({
            url: url,
            method: methodName,
            data: payload,
            success: function (data) {
                resolve(data)
            },
            error: function (error) {
                reject(error)
            },
        })
    });

    p.then(function(data) {
        successCallBack(data);
    });

    p.catch(function(error){
        errorCallBack(error);
    });
}

function jQueryAjaxJSON(url, payload, methodName, successCallBack, errorCallBack) {
    var p = new Promise(function (resolve, reject) {
        $.ajax({
            url: url,
            method: methodName,
            data: payload,
            contentType: 'application/json',
            success: function (data) {
                resolve(data)
            },
            error: function (error) {
                reject(error)
            },
        })
    });

    p.then(function (data) {
        successCallBack(data);
    });

    p.catch(function (error) {
        errorCallBack(error);
    });
}